import {useSelector} from "react-redux";
import {selectEvents} from "joynt/state/selectors/joint";

export function useEvents(parent) {
    return useSelector(s => selectEvents(s, parent));
}